import { PartySource, PartyTypes } from '@shared/party';
import moment from 'moment';

export enum FloorPlanPartyType {
  serving = 'Serving',
  waiting = 'Waiting',
  booked = 'Booked',
  checkedIn = 'Checked In',
  overdue = 'Overdue',
  completed = 'Completed',
  canceled = 'Canceled',
}

export const cardTypeColorMap: Record<FloorPlanPartyType, { background: string; text: string }> = {
  [FloorPlanPartyType.checkedIn]: {
    background: '#FFB800',
    text: '#000',
  },
  [FloorPlanPartyType.booked]: {
    background: '#80D8F4',
    text: '#000',
  },
  [FloorPlanPartyType.serving]: {
    background: '#0EAD69',
    text: '#fff',
  },
  [FloorPlanPartyType.waiting]: {
    background: '#7685B4',
    text: '#fff',
  },
  [FloorPlanPartyType.overdue]: {
    // Dark text: white on this orange is ~2.9:1 contrast, black is ~7.4:1 (WCAG AA needs 4.5:1).
    background: '#E67E22',
    text: '#000',
  },
  [FloorPlanPartyType.completed]: {
    background: '#0EAD69',
    text: '#fff',
  },
  [FloorPlanPartyType.canceled]: {
    background: '#EB6E6E',
    text: '#fff',
  },
};

interface PartyLike {
  seated_time?: number | null;
  checkin_time: number | null;
  completedAt?: number | null;
  canceled_time?: number | null;
  type?: PartyTypes;
  source?: PartySource;
  quoted_time: number;
}

export const getPartyType = (party: PartyLike): FloorPlanPartyType => {
  if (party.canceled_time) {
    return FloorPlanPartyType.canceled;
  }

  if (party.completedAt) {
    return FloorPlanPartyType.completed;
  }

  if (party.seated_time) {
    return FloorPlanPartyType.serving;
  }

  if (party.checkin_time && party.type === PartyTypes.reservation) {
    return FloorPlanPartyType.checkedIn;
  }

  if (
    (party.checkin_time && party.type === PartyTypes.walkIn) ||
    party.source === PartySource.square
  ) {
    return FloorPlanPartyType.waiting;
  }

  if (party?.quoted_time < moment.now()) {
    return FloorPlanPartyType.overdue;
  }

  return FloorPlanPartyType.booked;
};
